// NPM Imports
import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { Tooltip, Toastr } from "../../../revvComponents";

// Components Imports
import NavBarItem from "./NavBarItem";
import NavBarItemOnboard from "./NavBarItemOnboard";
import NavBarItemUpgrade from "./NavBarItemUpgrade";
import {
  FeatureGating,
  OnBoardGating,
  UpgradePopUpV2,
} from "../../../commonComponents";
import { SignOut } from "../../AuthComponents";
import NavbarShieldHelpPopup from "./NavbarShieldHelpPopup";
import NavBarInviteTeammate from "./NavBarInviteTeammate";
import ShowUserLimitIncreaseRequestPopupV2 from "../../ShowUserLimitIncreaseRequestPopupV2";
import ShowUserLimitIncreaseRequestPopup from "../../ShowUserLimitIncreaseRequestPopup";
// import ReferralPopup from "../../SettingsWrapper/ReferralPopup";
// import ShowPlanSubscribeRequestPopup from "../../ShowPlanSubscribeRequestPopup";

// Action Imports
import toggleView from "../../../actions/NavbarActions";
// import { checkInboxUnreadNotification } from "../../../actions/CommonActions/commonActions";

import { buttonClickEvent } from "../../../gtm/gtmutils";
import GTM_EVENTS from "../../../gtm/gtmevents";

// Internal Imports
import { AmplitudeUtils, GlobalUtils } from "../../../utils";
import {
  BILLING,
  EVENTS,
  NAVBAR,
  PATHS,
  SETTINGS,
  IMAGE_URLS,
} from "../../../constants";
import {
  readDataFromLocalStorage,
  applyRbac,
  isEnterprisePlan,
  checkFreePlan,
} from "../../../utils/globalUtils";
import { USER_ROLES } from "../../../constants/roleList";

// service Imports
// import { getUserFeaturesService } from "../../../actions/UserActions/userService";
import { getMeterUsageService } from "../../../actions/CommonActions/commonService";

// Destructuring
const { NAVITEMS, GATING_TYPES } = NAVBAR;
const { BILLINGS_ENTITY_CONSUMPTION_POINT, BILLING_PLANS } = BILLING;
const { isFreeBillingPlan } = GlobalUtils;
const { AddUser, Settings, SettingsSelected, Shield } = IMAGE_URLS;

// Declarations
// let setTimeoutRef = null;

class NavBar extends Component {
  profileRef = React.createRef();

  state = {
    showProfile: false,
    showShieldHelpPopup: false,
    showTeammatePopup: false,
    // rerenderNavbarComponent: false,
    userConsumptionRecord: {},
    showUserConsumptionPopup: false,
    // showReferralPopup: false,
    planSubscribeRequestPopup: false,
    // billingInfo: null,
  };

  componentDidMount() {
    // getUserFeaturesService()
    //   .then(() => {
    //     this.setState({
    //       rerenderNavbarComponent: true,
    //     });
    //   })
    //   .catch(error => {
    //     const message = handleApiErrMsg(error);
    //     Toastr.showToastr({
    //       type: "failure",
    //       message,
    //       timeout: 2000,
    //     });
    //   });

    // this._checkUserConsumption();
    // this._getBillingInfo();
    // call the below method only for one setTimeout timer reference
    // if (!setTimeoutRef) {
    //   this._checkInboxUnseenNotifications();
    // }
    AmplitudeUtils.amplitudeLogEvent(EVENTS.EVENT_NAMES.NAV_BAR_ITEM_CLICKED);
  }

  componentDidUpdate() {
    AmplitudeUtils.amplitudeLogEvent(EVENTS.EVENT_NAMES.NAV_BAR_ITEM_CLICKED);

    // if (this.state.rerenderNavbarComponent) {
    //   this._stopRerender();
    // }
  }

  _checkUserConsumption = () =>
    getMeterUsageService(BILLINGS_ENTITY_CONSUMPTION_POINT.USER_LICENCES)
      .then(res => {
        this.setState({ userConsumptionRecord: res });
      })
      .catch(error => {
        console.error(
          `getMeterUsageService => getMeterUsageService => Error : ${error}`,
        );
        Toastr.showToastr({
          type: "failure",
          message: "Oops! Failed to fetch user consumption record.",
          timeout: 3000,
        });
      });

  // _stopRerender = () => {
  //   this.setState({
  //     rerenderNavbarComponent: false,
  //   });
  // };

  // Make an API call (every 5 Min of time interval)
  // to get the inbox unseen notifications status
  // _checkInboxUnseenNotifications = () => {
  //   this.props
  //     .checkInboxUnreadNotification()
  //     .then(() => {
  //       setTimeoutRef = setTimeout(this._checkInboxUnseenNotifications, 300000);
  //     })
  //     .catch(error => {
  //       console.error(
  //         `index.js (NavBar) => _checkInboxUnseenNotifications => ${error}`,
  //       );
  //     });
  // };

  _handleView = () => {
    AmplitudeUtils.amplitudeLogEvent(
      EVENTS.EVENT_NAMES.DOCUMENTATION_HUB_VIEWED,
    );
  };

  _toggleView = view => {
    this.props.toggleView(view);
  };

  _toggleProfile = () => {
    // attach/remove event handler
    if (!this.state.showProfile) {
      document.addEventListener(
        "click",
        this._handleShowProfileOutsideClick,
        false,
      );
    } else {
      document.removeEventListener(
        "click",
        this._handleShowProfileOutsideClick,
        false,
      );
    }
    this.setState(prevState => ({
      showProfile: !prevState.showProfile,
    }));
  };

  _handleShowProfileOutsideClick = e => {
    const node = this.profileRef.current;
    // ignore clicks on the component itself
    if (node && node.contains(e.target)) {
      return;
    }
    this._toggleProfile();
  };

  _decideNavItemsView = item => {
    switch (item.featureGating && item.featureGating.type) {
      case GATING_TYPES.FEATURE:
        return (
          <FeatureGating
            // reRender={this.state.rerenderNavbarComponent}
            name={item.featureGating.featureName}
            altComponent={<NavBarItemUpgrade item={item} />}>
            <NavBarItem
              item={item}
              location={this.props.location}
              newNotification={this.props.newNotification}
            />
          </FeatureGating>
        );
      case GATING_TYPES.ON_BOARD:
        return (
          <OnBoardGating
            name={item.featureGating.name}
            altComponent={<NavBarItemOnboard item={item} />}>
            <NavBarItem
              item={item}
              location={this.props.location}
              newNotification={this.props.newNotification}
            />
          </OnBoardGating>
        );
      default:
        return (
          <NavBarItem
            item={item}
            location={this.props.location}
            newNotification={this.props.newNotification}
          />
        );
    }
  };

  _toggleNavbarPopup = (type, flag) => {
    if (type === "showShieldHelpPopup") {
      buttonClickEvent(GTM_EVENTS.TRUST_CENTER_CLICK);
    }
    this.setState({ [type]: flag });
  };

  _decideInviteUserView = async () => {
    await this._checkUserConsumption();
    if (
      this.state.userConsumptionRecord.limit <=
      this.state.userConsumptionRecord.usage
    ) {
      this._toggleNavbarPopup("showUserConsumptionPopup", true);
    } else {
      this._toggleNavbarPopup("showTeammatePopup", true);
    }
  };

  _showOrHideNavbarItem = (itemName, userSignUpInfo) => {
    if (itemName === "FEILDS") {
      const currentPlan = userSignUpInfo && userSignUpInfo.billing_plan;
      if (
        currentPlan.split("-").includes("enterprise") ||
        currentPlan === BILLING_PLANS.ENTERPRISE_MONTHLY ||
        currentPlan === BILLING_PLANS.ENTERPRISE_ANNUAL ||
        currentPlan === BILLING_PLANS.ENTERPRISE_ANNUAL_V3 ||
        currentPlan === BILLING_PLANS.ENTERPRISE_MONTHLY_V3 ||
        currentPlan === BILLING_PLANS.ENTERPRISE_ANNUAL_V3_1 ||
        currentPlan === BILLING_PLANS.ENTERPRISE_ANNUAL_V3_2 ||
        currentPlan === BILLING_PLANS.ENTERPRISE_ANNUAL_V3_3 ||
        currentPlan === BILLING_PLANS.ENTERPRISE_MONTHLY_V3_1 ||
        currentPlan === BILLING_PLANS.ENTERPRISE_MONTHLY_V3_2 ||
        currentPlan === BILLING_PLANS.ENTERPRISE_MONTHLY_V3_3
      )
        return true;
      return false;
    }
    return true;
  };

  render() {
    // READ FROM LOCAL STORAGE
    const userData = readDataFromLocalStorage("revvsalesUser");
    const userLimitPop = isEnterprisePlan() ? (
      <ShowUserLimitIncreaseRequestPopup
        userConsumptionRecord={this.state.userConsumptionRecord}
        onClose={this._toggleNavbarPopup}
      />
    ) : (
      <ShowUserLimitIncreaseRequestPopupV2
        userConsumptionRecord={this.state.userConsumptionRecord}
        onClose={this._toggleNavbarPopup}
      />
    );
    // LOCAL VARIABLE DECLARATIONS
    const USER_PROFILE_IMAGE_URL = userData ? userData.image_url : null;
    const NAVDATA = NAVITEMS[this.props.currentView];
    let popupSpace = null;
    if (this.state.showShieldHelpPopup) {
      popupSpace = (
        <NavbarShieldHelpPopup closePopup={this._toggleNavbarPopup} />
      );
    } else if (this.state.showTeammatePopup) {
      popupSpace = (
        <NavBarInviteTeammate
          closePopup={this._toggleNavbarPopup}
          userConsumptionRecord={this.state.userConsumptionRecord}
        />
      );
    } else if (this.state.showUserConsumptionPopup) {
      popupSpace = isFreeBillingPlan() ? (
        <UpgradePopUpV2
          type="generic"
          onClose={() =>
            this._toggleNavbarPopup("showUserConsumptionPopup", false)
          }
        />
      ) : (
        userLimitPop
      );
    }
    //  else if (this.state.showReferralPopup) {
    // popupSpace = <ReferralPopup closePopup={this._toggleNavbarPopup} />;
    // }
    else if (this.state.planSubscribeRequestPopup) {
      popupSpace = (
        <UpgradePopUpV2
          type="generic"
          onClose={() =>
            this._toggleNavbarPopup("planSubscribeRequestPopup", false)
          }
        />
      );
    }
    const isFreePlan =
      this.props.billingInfo !== undefined &&
      this.props.billingInfo.plan_type !== undefined
        ? checkFreePlan(this.props.billingInfo.plan_type)
        : true;

    const landingPage = isFreePlan
      ? PATHS.APP_MAIN_PAGE_FREE_USER
      : PATHS.APP_MAIN_PAGE;

    return (
      <div className="navbar-wrapper">
        {popupSpace}
        {/* LOGO SECTION */}
        <section className="navbar-logo">
          <Link to={landingPage}>
            <img
              src="https://d34fwl795uvawg.cloudfront.net/images/reactgrid/revv-logo-blue-pink.svg"
              className="navbar-logo-img"
              alt="Revv"
              width="34px"
              height="34px"
            />
          </Link>
        </section>
        {/* NAVIGATION LISTING SECTION */}
        <section>
          <ul className="navbar-list-wrapper">
            {applyRbac(
              NAVDATA.navItems,
              readDataFromLocalStorage("revvsalesUserPermissions")
                ? readDataFromLocalStorage("revvsalesUserPermissions")
                : [],
            )
              .filter(item => !(isFreePlan && item.freeDisabled))
              .map(
                item =>
                  this._showOrHideNavbarItem(
                    item.name,
                    readDataFromLocalStorage("userSignUpInfo"),
                  ) && (
                    <li key={item.name}>{this._decideNavItemsView(item)}</li>
                  ),
              )}
          </ul>
        </section>
        {/* SETTINGS & PROFILE NAVIGATION SECTION */}
        <section className="navbar-info-wrapper">
          {/* <div>
            <Link to="#" className="navbar-view-toggle" onClick={() => this._toggleView(NAVDATA.alias)}>
              {NAVDATA.text}
            </Link>
          </div> */}
          <div className="navbar-profile-wrapper">
            <ul className="navbar-profile-info">
              {/* {userData && userData.org_id && (
                <li className="navbar-icons">
                  <Tooltip placement="right" overlay="Refer and get benefits!">
                    <span
                      className="i-settings navbar-setting-icon"
                      onClick={() =>
                        this._toggleNavbarPopup("showReferralPopup", true)
                      }
                      onKeyPress={() => {}}
                      tabIndex="0"
                      role="button">
                      <span aria-label="referral-gift-wrapper" role="img">
                        🎁
                      </span>
                    </span>
                  </Tooltip>
                </li>
              )} */}

              {userData &&
                !isFreePlan &&
                userData.roles &&
                userData.roles.length > 0 &&
                userData.roles[0].name === USER_ROLES.ADMIN && (
                  <li className="navbar-icons">
                    <Tooltip
                      placement="right"
                      overlay="Invite team members to Revv">
                      <span
                        className="navbar-setting-icon ic-invite-user"
                        onClick={this._decideInviteUserView}
                        onKeyPress={() => {}}
                        tabIndex="0"
                        role="button">
                        <img
                          src={AddUser}
                          data-test="revvsales-trust-center"
                          className="revvsales-tc-img"
                          alt="Add user"
                          width="26px"
                          height="26px"
                        />
                      </span>
                    </Tooltip>
                  </li>
                )}

              <li className="navbar-icons">
                <Tooltip placement="right" overlay="Settings">
                  <Link
                    data-test="navbar-settings"
                    to={`/settings/${SETTINGS.SETTINGS_DEFAULT_VIEW_URL}`}>
                    <i className="i-settings">
                      <img
                        src={
                          this.props.location.pathname.includes("settings")
                            ? SettingsSelected
                            : Settings
                        }
                        alt="Settings"
                        className="revvsales-tc-img"
                        data-test="revvsales-setting-icon"
                        width="26px"
                        height="26px"
                      />
                    </i>
                  </Link>
                </Tooltip>
              </li>
              {/* <li className="navbar-icons">
                  <Tooltip placement="right" overlay="Notifications">
                    <FontAwesomeIcon icon={["far", "bell"]} />
                  </Tooltip>
                </li> */}
              <li className="navbar-icons">
                <Tooltip placement="right" overlay="Revv Trust Center">
                  <span
                    className="navbar-setting-icon"
                    onClick={() =>
                      this._toggleNavbarPopup("showShieldHelpPopup", true)
                    }
                    onKeyPress={() => {}}
                    tabIndex="0"
                    role="button">
                    <img
                      src={Shield}
                      data-test="revvsales-trust-center"
                      className="revvsales-tc-img"
                      alt="Revv Trust Center"
                      width="26px"
                      height="26px"
                    />
                  </span>
                </Tooltip>
              </li>

              <li
                className="nav-profile-menuwrapper"
                data-test="navbar-profile-menu">
                <img
                  alt="User Profile"
                  data-test="navbar-avator"
                  className="navbar-avator"
                  onClick={this._toggleProfile}
                  onKeyPress={this._toggleProfile}
                  role="presentation"
                  src={USER_PROFILE_IMAGE_URL}
                  width="42px"
                  height="42px"
                />
                {this.state.showProfile ? (
                  <div className="nav-profile-menu" ref={this.profileRef}>
                    <ul>
                      <li>
                        <Link
                          to={`/settings/${SETTINGS.SETTINGS_DEFAULT_VIEW_URL}`}>
                          <div
                            className="nav-profile-menuitem"
                            data-test="navbar-open-profile">
                            <i>
                              <FontAwesomeIcon icon={["far", "user"]} />
                            </i>
                            My Profile
                          </div>
                        </Link>
                      </li>
                      <li>
                        <SignOut />
                      </li>
                    </ul>
                  </div>
                ) : null}
              </li>
              {Object.keys(this.props.billingInfo).length > 0 &&
                (this.props.billingInfo.subscription.status === "in_trial" ||
                  (this.props.billingInfo.subscription.status === "active" &&
                    this.props.billingInfo.auto_downgraded === true)) && (
                  <li className="navbar-upgrade">
                    <div
                      className="navbar-upgrade-text"
                      data-test="navbar-upgrade"
                      onClick={() =>
                        this._toggleNavbarPopup(
                          "planSubscribeRequestPopup",
                          true,
                        )
                      }
                      onKeyPress={() => null}
                      role="button"
                      tabIndex="0">
                      Upgrade
                    </div>
                  </li>
                )}
            </ul>
          </div>
        </section>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const currentView = state.NavBarStore.appView;
  const { newNotification, billingInfo } = state.CommonStore;
  return { currentView, newNotification, billingInfo };
};

const mapDispatchToProps = {
  toggleView: view => toggleView(view),
  // checkInboxUnreadNotification,
};

export default connect(mapStateToProps, mapDispatchToProps)(NavBar);
